import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ControlRegistration, Registration } from 'src/app/shared/models/registration';
import { WorkerAndToolService } from 'src/app/shared/services/worker-and-tool.service';
import { ToolbarService } from 'src/app/shared/services/toolbar.service';
import { HoursOption } from 'src/app/shared/models/hours-option';

import { alert } from 'devextreme/ui/dialog';
import { EditorPreparingEvent } from 'devextreme/ui/data_grid';

import { DxDataGridComponent } from "devextreme-angular";
import { RegistrationWorkflowService, WorkflowContext } from '../../shared/services/registration-workflow.service';

@Component({
    selector: 'app-registration-workers-hour',
    templateUrl: './registration-workers-hour.component.html',
    styleUrls: ['./registration-workers-hour.component.scss'],
    standalone: false
})

export class RegistrationWorkersHourComponent {
  registration!: Registration | undefined;
  option: HoursOption | any;

  optionSubscription: any;
  forwardSubscription: any;
  backSubscription: any;

  oreLavorateEditorOptions: object;

  hasControls = false;

  selectedControls: ControlRegistration[] = [];

  @ViewChild(DxDataGridComponent, { static: false }) grid!: DxDataGridComponent;

  constructor(
    private service: WorkerAndToolService,
    private toolbar: ToolbarService,
    private route: ActivatedRoute,
    private router: Router,
    private workflowService: RegistrationWorkflowService) {

      this.oreLavorateEditorOptions = {
          mode: 'number',
          showSpinButtons: false
      }

    this.registration = service.getNewRegistration();
 }

    ngOnInit() {
      this.optionSubscription = this.service.getHoursOptionObservable().subscribe(val => {
        this.option = val;
      });

      this.backSubscription = this.toolbar.backClickedEvent.subscribe(()=>this.Back());
      this.forwardSubscription = this.toolbar.forwardClickedEvent.subscribe(()=>this.Forward());

      this.toolbar.BackVisibleChanged(true);
      this.toolbar.SaveVisibleChanged(false);
      this.toolbar.ForwardVisibleChanged(true);
      this.toolbar.CancelVisibleChanged(false);
      this.toolbar.PlusVisibleChanged(false);
      this.toolbar.EditVisibleChanged(false);
      this.toolbar.DeleteVisibleChanged(false);
      this.toolbar.CopyVisibleChanged(false);
      this.toolbar.MenuVisibleChanged(false);

      let regId = this.route.snapshot.paramMap.get('id');

      if (regId == null) {
        regId = "-1";
      }

      this.service.getTempRegistration(Number(regId)).then((reg) => {
        this.registration = reg;

        if (this.registration) {
          this.service.getHasControls(this.registration).then(c => { this.hasControls = c; });
        }

      });


    }

    ngOnDestroy() {
      this.optionSubscription?.unsubscribe()
      this.backSubscription?.unsubscribe();
      this.forwardSubscription?.unsubscribe();
    }


    verificaOreNegative(e: { value: number; }) {
      return e.value >= 0;
    }

    verificaOreAZero(e: { value: number; }) {
      return e.value != 0;
    }

    verificaOreOltreGiornata(e: { value: number; }) {
      return e.value < 24;
    }

    verificaFrazioni(e: { value: number; }) {
      return (e.value * 40 % 10) == 0;
    }

    onEditorPreparing(e: EditorPreparingEvent) {
      if (e.dataField === "oreLavorate" && e.parentType === "dataRow") {
          e.editorOptions.onFocusIn = (function (args: { element: { querySelector: (arg0: string) => { (): any; new(): any; select: { (): void; new(): any; }; }; }; }): void {
            console.log(args.element);
            args.element.querySelector(".dx-texteditor-input").select();
          })
      }
    }

  Forward() {
    this.grid.instance.saveEditData().then(() => this.saveRegistration());
  }

  private saveRegistration() {

    if (this.registration) {

      this.registration.workerRegistrations = this.registration.workerRegistrations.filter(x => x.oreLavorate > 0);

      const ctx: WorkflowContext = { options: this.option, siteManagerMode: true, hasControls: this.hasControls };

      if (this.workflowService.isFinalStep('registration-worker-hour', ctx)) {
        this.registration.id ??= 0;
        if (this.registration.id > 0) {
          this.service.editRegistration(this.registration, this.registration.id)
            .then(() => this.router.navigate(['/registrations']))
            .catch(err => { if (!this.service.showSaveError(err)) throw err; });
        } else {
          this.service.addRegistration(this.registration)
            .then(() => this.router.navigate(['/registrations']))
            .catch(err => { if (!this.service.showSaveError(err)) throw err; });
        }
      } else {
        this.service.editTempRegistration(this.registration, this.registration.id ?? 0)
          .then((regId) => {
            const next = this.workflowService.getNextStep('registration-worker-hour', ctx);
            this.router.navigate(['/' + next, { id: regId }]);
          });
      }
    }
    else {
      alert("Nessuna registrazione individuata", "Errore");
    }
  }
  


    Back()
    {
      this.router.navigate(['/registration-worker-select', { id: this.registration?.id }]);
    }
}
